<template>
  <div class="mt-1 pr-1 pl-2">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <section>
          <div class="ak-page-toolbar px-4 mt-2">
            <div class="ak-page-toolbar__title">
              <h1 class="ak-page-toolbar__heading">Laporan Arus Kas</h1>
              <span v-if="periodeText" class="ak-page-toolbar__period">s.d. {{ periodeText }}</span>
            </div>

            <div class="ak-page-toolbar__actions lr-filters">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    filled
                    rounded
                    dense
                    hide-details
                    readonly
                    :color="set_color"
                    placeholder="Pilih Tanggal Cutoff"
                    :value="cutoffText"
                    prepend-inner-icon="mdi-calendar-range"
                    class="fs-12 lr-filters__text-field"
                    style="border-radius: 6px; width: 200px; min-width: 200px; max-width: 200px;"
                    v-bind="attrs"
                    v-on="on">
                  </v-text-field>
                </template>

                <v-date-picker
                  v-model="filter.cutoff"
                  no-title
                  locale="id-ID"
                  :color="set_color"
                  @change="onCutoffChange">
                </v-date-picker>
              </v-menu>

              <v-select
                filled
                rounded
                dense
                hide-details
                class="fs-12 lr-filters__select"
                style="border-radius: 6px; width: 130px; min-width: 130px; max-width: 130px;"
                :color="set_color"
                placeholder="Posisi"
                :items="position"
                v-model="filter.position"
                @change="fetch">
              </v-select>

              <v-btn
                @click="exports()"
                :loading="process.export"
                elevation="0"
                rounded
                small
                min-height="30"
                class="ak-filter-action ak-filter-btn ak-filter-btn--pdf"
                title="Export PDF">
                <v-icon size="18" class="ak-filter-btn--pdf__icon">mdi-file-pdf-box</v-icon>
                <span class="ak-filter-btn__label">PDF</span>
              </v-btn>

              <v-btn
                @click="exports_excel()"
                :loading="process.export_excel"
                elevation="0"
                rounded
                small
                min-height="30"
                class="ak-filter-action ak-filter-btn ak-filter-btn--excel"
                title="Export Excel">
                <v-icon size="18" class="ak-filter-btn--excel__icon">mdi-microsoft-excel</v-icon>
                <span class="ak-filter-btn__label">Excel</span>
              </v-btn>
            </div>
          </div>

          <v-row class="pa-4 px-4">
            <v-col cols="12" class="py-0">
              <v-card flat style="border-radius: 10px;">
                <v-card-text v-if="process.load" class="ak-loading">
                  <div class="text-center" style="width: 320px;">
                    <div class="mb-4 title">Mohon Tunggu . . .</div>
                    <v-progress-linear
                      :color="set_color"
                      indeterminate
                      rounded
                      height="10">
                    </v-progress-linear>
                  </div>
                </v-card-text>

                <template v-else>
                  <div v-if="rows.length > 0" class="pa-0">
                    <arus-kas-report-table
                      :rows="rows"
                      :columns="columns">
                    </arus-kas-report-table>
                  </div>

                  <div v-else class="ak-empty">
                    <v-img
                      class="mx-auto"
                      contain
                      alt="empty"
                      :width="90"
                      :height="90"
                      :src="require('@/assets/image/empty.png')">
                    </v-img>
                    <div class="mt-3 fs-16">Belum Ada Laporan Arus Kas</div>
                  </div>
                </template>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  import ArusKasReportTable from "./ArusKasReportTable.vue"

  export default {
    components: {
      ArusKasReportTable
    },
    data () {
      return {
        dateMenu: false,

        dialog: {
          snackbar: false
        },

        filter: {
          cutoff: moment().endOf('month').format('YYYY-MM-DD'),
          position: 'Internal'
        },
        position: ['Internal', 'Public'],

        rows: [],
        columns: [],
        periode: '',

        process: {
          load: false,
          export: false,
          export_excel: false
        },

        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      set_color () {
        return this.$store.state.color
      },
      cutoffText () {
        return this.filter.cutoff ? moment(this.filter.cutoff).format('DD MMM YYYY') : ''
      },
      periodeText () {
        // if (this.periode) return this.periode

        return this.filter.cutoff ? moment(this.filter.cutoff).locale('id').format('D MMMM YYYY') : ''
      },
      exportParams () {
        return {
          cutoff: this.filter.cutoff,
          position: (this.filter.position || '').toLowerCase()
        }
      }
    },
    created () {
      if (String(this.$store.state.user.cat_id) === '21' || String(this.$store.state.user.cat_id) === '23') {
        this.position = ['Public']
        this.filter.position = 'Public'
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      onCutoffChange () {
        this.dateMenu = false
        this.fetch()
      },

      async fetch () {
        this.process.load = true
        this.rows = []
        this.columns = []

        await get(`arus_kas/data`, {
          params: this.exportParams
        }).then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            let data = res.results.data

            this.rows = data.row_array || []
            this.columns = data.columns || []
            this.periode = data.periode || ''
          } else {
            this.message.error = res.message
          }
        })
      },

      async exports () {
        this.message.error = ''
        this.process.export = true

        await axios({
          url: `${process.env.VUE_APP_API_URL}/arus_kas/export_pdf`,
          method: 'GET',
          responseType: 'blob',
          params: this.exportParams,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export = false

          let disposition = res.headers['content-disposition']
          let filename = ''

          if (disposition) {
            let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            let matches = filenameRegex.exec(disposition)
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '')
            }
          }

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport PDF'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename || 'laporan-arus-kas.pdf')
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        }).catch(() => {
          this.process.export = false
          this.message.error = 'Gagal mengeksport PDF'
        })
      },

      async exports_excel () {
        this.message.error = ''
        this.process.export_excel = true

        await axios({
          url: `${process.env.VUE_APP_API_URL}/arus_kas/export_excel`,
          method: 'GET',
          responseType: 'blob',
          params: this.exportParams,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export_excel = false

          let disposition = res.headers['content-disposition']
          let filename = ''

          if (disposition) {
            let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            let matches = filenameRegex.exec(disposition)
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '')
            }
          }

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport Excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename || 'laporan-arus-kas.xlsx')
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        }).catch(() => {
          this.process.export_excel = false
          this.message.error = 'Gagal mengeksport Excel'
        })
      }
    }
  }
</script>

<style scoped>
  .ak-page-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .ak-page-toolbar__title {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .ak-page-toolbar__heading {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #111827;
    line-height: 1.2;
  }

  .ak-page-toolbar__period {
    display: block;
    font-size: 12px;
    font-weight: 400;
    color: #6b7280;
    line-height: 1.3;
  }

  .ak-page-toolbar__actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  .ak-filter-action {
    flex: 0 0 auto;
    border-radius: 6px !important;
  }

  .ak-filter-btn {
    min-height: 30px !important;
    height: 30px !important;
    padding: 0 10px !important;
    box-shadow: none !important;
    letter-spacing: normal;
    text-transform: none !important;
    font-weight: 600 !important;
    font-size: 11px !important;
  }

  .ak-filter-btn__label {
    line-height: 1;
    margin-left: 4px;
  }

  .ak-filter-btn::before {
    opacity: 0 !important;
  }

  /* Export PDF — Okabe-Ito vermillion */
  .ak-filter-btn--pdf {
    background-color: #fdf0e8 !important;
    border: 1px solid #e8b196 !important;
    color: #d55e00 !important;
  }

  .ak-filter-btn--pdf:hover {
    background-color: #fae3d4 !important;
    border-color: #d55e00 !important;
  }

  .ak-filter-btn--pdf__icon {
    color: #d55e00 !important;
  }

  /* Export Excel — Okabe-Ito bluish green */
  .ak-filter-btn--excel {
    background-color: #e6f5f0 !important;
    border: 1px solid #9dd4c0 !important;
    color: #009e73 !important;
  }

  .ak-filter-btn--excel:hover {
    background-color: #d4ede4 !important;
    border-color: #009e73 !important;
  }

  .ak-filter-btn--excel__icon {
    color: #009e73 !important;
  }

  .ak-loading,
  .ak-empty {
    min-height: calc(100vh - 320px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 16px;
  }

  .ak-empty {
    flex-direction: column;
    color: #6b7280;
  }

  @media (max-width: 600px) {
    .ak-page-toolbar {
      flex-direction: column;
      align-items: stretch;
    }

    .ak-filter-btn__label {
      display: none;
    }

    .ak-filter-btn {
      padding: 0 8px !important;
      min-width: 30px !important;
    }
  }

  .lr-filters >>> .v-text-field,
  .lr-filters >>> .v-select {
    border-radius: 6px;
  }

  .lr-filters >>> .v-text-field--rounded > .v-input__control > .v-input__slot {
    padding: 0 15px !important;
  }

  .lr-filters >>> .v-text-field--filled.v-input--dense > .v-input__control > .v-input__slot,
  .lr-filters >>> .v-text-field--outlined.v-input--dense > .v-input__control > .v-input__slot,
  .lr-filters >>> .v-select.v-input--dense > .v-input__control > .v-input__slot {
    min-height: 30px !important;
  }

  .lr-filters >>> .v-text-field--enclosed.v-input--dense .v-input__append-inner,
  .lr-filters >>> .v-text-field--enclosed.v-input--dense .v-input__append-outer {
    margin-top: 4px !important;
  }

  .lr-filters >>> .v-text-field--enclosed.v-input--dense .v-input__prepend-inner {
    margin-top: 4px !important;
  }

  .lr-filters >>> .v-text-field--enclosed.v-input--dense .v-input__slot .v-icon {
    font-size: 16px !important;
  }

  .lr-filters >>> .v-text-field input,
  .lr-filters >>> .v-select .v-select__selection {
    font-size: 12px !important;
    font-weight: 400;
    color: #111827;
  }

  .ak-empty .fs-16 {
    font-size: 14px !important;
    font-weight: 500;
    color: #6b7280;
  }
</style>